import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  showLogoutButton: boolean = false;

  showFormerTeamButton: boolean = true;

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.showLogoutButton = this.shouldShowButton(event.url);
        // this.showFormerTeamButton = !this.showFormerButton(event.url);
        this.showFormerTeamButton = false;
      }
    });
  }

  shouldShowButton(url: string): boolean {
    return url.includes('admin');
  }
 
  showFormerButton(url: string) {
    return url?.includes('employee-details') ?? false;
  }

  isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  async logout(): Promise<void> {
    this.authService.deleteToken();

    await this.router.navigate(['/admin/login']);
  }
}
